import React, { useEffect } from "react";

//redux
import { useSelector, connect, useDispatch } from "react-redux";

//serverpath
import { baseURL } from "../util/Config";

//sweet alert
import { alert, warning } from "../util/Alert";

//action
import { deleteGift } from "../store/gift/action";

// type
import { OPEN_GIFT_DIALOG } from "../store/gift/types";

//routing
import { useNavigate } from "react-router-dom";

//image
import noImage from "../assets/images/noImage.png";

import SVGA from "svgaplayerweb";
import { usePermission } from "../context/PermissionProvider";

const AllGift = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { can } = usePermission();
  const canCreate = can("admin/gift", "Create");
  const canEdit = can("admin/gift", "Edit");
  const canDelete = can("admin/gift", "Delete");

  const handleDelete = (giftId) => {


    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          props.deleteGift(giftId);
          alert("Deleted!", `Gift has been deleted!`, "success");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleEdit = (data) => {


    dispatch({ type: OPEN_GIFT_DIALOG, payload: data });
  };
  return (
    <>
      {props?.data?.gift?.length > 0 ? (
        props?.data?.gift?.map((data, index) => {
          return (
            <>
              <div
                className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4"
                key={index}
                onClick={() => {
                  sessionStorage.setItem("CategoryId", data._id);
                  // navigate("/admin/giftCategory/gift");
                }}
              >
                <div
                  style={{
                    boxShadow: "0 10px 25px rgba(0,0,0,0.4)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "rgba(255,77,141,0.3)";
                    e.currentTarget.style.boxShadow = `0 10px 30px rgba(255,77,141,0.25)`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "#1F2937";
                    e.currentTarget.style.boxShadow =
                      "0 10px 25px rgba(0,0,0,0.4)";
                  }}
                  className="card contact-card card-bg"
                >
                  <div className="card-body p-1">
                    <div className="row px-3 py-4 ">
                      <div className="col-4 ps-4">
                        {data?.type === 2 ? (
                          <img
                            src={
                              data?.svgaImage
                                ? baseURL + data?.svgaImage
                                : noImage
                            }
                            width="70px"
                            height="70px"
                            alt="img"
                            style={{
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                            className="mr-3"
                          />
                        ) : (
                          <img
                            src={data?.image ? baseURL + data?.image : noImage}
                            width="70px"
                            height="70px"
                            alt="img"
                            style={{
                              objectFit: "contain",
                              borderRadius: "50%",
                            }}
                            className="mr-3"
                          />
                        )}
                      </div>

                      <div
                        className="col-8 text-end pe-4"
                        style={{
                          padding: 0,
                          paddingLeft: 5,
                        }}
                      >
                        <div className="contact-card-info mt-2 mb-5 px-3">
                          <h2 className="text-white">Coin: {data?.coin}</h2>
                        </div>
                        <div className="d-flex gap-2 justify-content-end">
                          {canEdit && (
                            <button
                              type="button"
                              className="edit-btn btn-circle  m-b-xs"
                              onClick={() => handleEdit(data)}
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                          )}

                          {canDelete && (
                            <button
                              type="button"
                              className="btn-circle delete-btn m-b-xs"
                              onClick={() => handleDelete(data?._id)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })
      ) : (
        <tr>
          <td colSpan="6" align="center">
            Nothing to show!!
          </td>
        </tr>
      )}
    </>
  );
};

export default connect(null, { deleteGift })(AllGift);
